<template>
  <v-container class="text-align-left">

  <div class="display-1 mt-4">
    Privacy Policy
  </div>

  <hr />
  <div class="content">
    <div class="subheading font-weight-bold">
      Last modified: May 13, 2020<br /><br />
    </div>

    <!-- Summary ********** -->
    <div style="background-color:#FFFACD" class="text-xs-left">

      <div class="sectionTitle">Privacy Overview</div>
      <ul>
        <li>
          We only collect information you knowingly provide.
        </li>
        <li>
          We don't sell or give your information to any 3rd parties except when used to support the
          transactions on the site (for example a mail service provider to email story updates).
        </li>
        <li> When you add story content into the site assume the information is available to any reader coming to the site.
        </li>
        <li> When you add an email address into the site, that remains private and only use it for communications directly with you.
        </li>
      </ul>
    </div>
    <!-- End of Summary ********** -->

    <br />
    <p>
      We at Add to the Story (“ATTS,” “we,” “us,” “our”) care about you
      (“you”, “user”, "writer", "author", "reader") and how your personal information is used and shared.
      We take your privacy seriously and are committed to creating a safe and secure
      environment for readers and writers of all ages. This Policy is designed to help you
      understand what information
      we collect, why we collect it, and what we do with it.  Thank you for
      taking the time to carefully read it.
    </p>

    <p>
      <div class="sectionTitle">About Add to the Story</div>
      ATTS is a place that allows anyone to read or write stories together.
      We think this is a fun and engaging activity for everyone.
      This Policy applies to all ATTS products, services, and website
      (collectively the “Service”).  This Policy describes how ATTS collects,
      uses and discloses the information it collects via the Service.
      By using the Service, you
      acknowledge that ATTS will handle your personal information as described
      in this Policy. Your use of our Service, and any dispute over privacy,
      is subject to this Policy and our Terms of Service, located at
      <a href="https://addtothestory.com/">https://addtothestory.com/</a>, which may from
      time to time be amended.

      This Privacy Policy applies to all websites owned and operated by Add to the Story.

      <div class="sectionTitle">Personal Data Collection</div>

      At our site, we do not collect Personal Data from individuals unless they provide it to us voluntarily and knowingly and as described
      in this Privacy Policy.

      <div class="sectionTitle">Data Collection</div>

      The site only collects information from reader to support reading stories. The only information collected
      is from 3rd party websites (Google Firebase and MailJet) to support user functions. You must read
      their terms of service which are implicitly included.

      <div class="sectionTitle">Use and Sharing of Personal Data </div>

      We do not sell Personal Data or other information you provide to us online with third parties. We may share Personal Data with the third parties who provide services for Add to the Story (such as site hosting or email). We use MailJet.com and Google Firebase as 3rd party providers for AddToTheStory. You are adivsed to read and understand their policies in addition to ours.

      <div class="sectionTitle">Parental Permissions</div>

      Add to the Story is committed to providing a safe, secure, and fun online experience for children who visit our site. We are dedicated to safeguarding any Personal Data collected online and to helping parents and children have positive experiences on the Internet.

      <br /><br />
      All children under the age of 13 must have parental permission.

      <br /><br />
      We also encourage children to use only their first name and no other identifying information in stories.

      <div class="sectionTitle">Cookies</div>

      See our Cookie Policy for more details.

      <div class="sectionTitle">Links to Other Sites</div>

      Add to the Story allows people to post links to their social media accounts and other sites. These sites and services are not maintained by us. These websites have their own privacy policies, which you should review prior to visiting them. We have no responsibility for linked websites and provide these links solely for the convenience and information of our visitors.

      <div class="sectionTitle">Site Security</div>

      The safety and security of your online experience is of the utmost concern to us. We take measures to implement reasonable physical, electronic, and managerial procedures to safeguard and help prevent unauthorized access, maintain data security, and correctly use the information we collect online.
      <div class="sectionTitle">Marketing Communications</div>

      We do not sell your data or use any 3rd party marketing services. You may receive transactional
      emails about your account such as story updates and  updates
      to the Add to the Story service. Additoinally, you may receive emails directly from Add to the Story about our services and offering.

      <div class="sectionTitle">Your Right to Access, Correct, and Delete Your Personal Data</div>
      You have the right to ask us which Personal Data we hold about you. In addition, you have
      the right to correct or delete Personal Data we hold about you. The simplest method is to
       remove your information through unsubscribing yourself using the webpage. You may also request a correction or deletion of the Personal Data we hold about you by mail at:  dan@addtothestory.com

      <div class="sectionTitle">How to contact us</div>

      If you have any questions about our Privacy Policy, you can contact us at: <b>dan@addtothestory.com</b>

  </div>

</v-container>

</template>

<script>

export default {
  name: 'Privacy',
  components: {

  },
  computed: {

  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.content {
  text-align:left;
  font-size: large;
}

.sectionTitle {
  font-weight: 700;
  font-size: large;
  font-variant: small-caps;
  margin-top:15px;
}
</style>
